import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataGridColumns } from 'src/app/interfaces/dagrid-columns';
import { Variations } from '../shopee-var-tier/shopee-var-tier.component';


@Component({
    selector: 'app-shopeenew-var',
    templateUrl: './shopee-var-new.component.html',
    styleUrls: ['./shopee-var-new.component.scss'],
    standalone: false
})
export class ShopeeVarNewComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
      if (changes.data.currentValue != changes.data.previousValue){
        this.parentRow = this.data.parentRow;
        this.condition = this.data.condition;
        this.row = this.data.row;
      };
  }

  @Input() data:any;
  parentRow:any;
  condition;
  row;
  customFields:DataGridColumns[] = [];
  variations:Variations[] = null;
  ngOnInit(): void {
    
    this.parentRow = this.data.parentRow;
    this.condition = this.data.condition;
    this.row = this.data.row;
    this.variations = null;
    if ( this.row['TIERVARIATION'] != null ){
      try{
        this.variations  = JSON.parse(this.row['TIERVARIATION']);
      }catch(exception){
        this.variations = [];
      }
    }
    
    if ( this.variations == null ){
      return;
    }

    try{
      this.variations.forEach(data=>{
        let custom:DataGridColumns = {
            columnDesc: data.name,
            columnName: data.name,
            header: data.name,
            type:'INT',
            order:1,
            visible:true,
            width: 80,
            validationError:JSON.stringify({
                type:'select',
                options:data.option_list.map((d,index,array)=>({view:d.option,value:index}))
            }),
            tab:'Atributo'
        }

        this.customFields.push(custom);
      });
    }catch(Exception){
      
    }
  }

  customFunction(form:UntypedFormGroup, customFields:DataGridColumns[], action:string){
      
      if ( action=='saving'){
        
        let tiers:number[] = [];
        customFields.forEach(data=>{
          tiers.push(form.get(data.columnName).value);
        });
        form.get('TIERINDEX').setValue(JSON.stringify(tiers));
      }else{
        let tiers:number[] = JSON.parse(form.get('TIERINDEX').value);
        
        if ( tiers != null && tiers.length > 0 ){
            customFields.forEach((data,index,array)=>{
              form.get(data.columnName).setValue(tiers[index]);
            });
        }
      }      
  }

  callbackFunction(dataRows:any[]){
      
      dataRows.forEach(row=>{
          if  ( row.TIERINDEX != null ){
            let tiers:number[] = JSON.parse(row.TIERINDEX);
            let i=0;
            this.customFields.forEach((data,index,array)=>{
              row[data.columnName]= tiers[i];
              i++;  
            });
            
          }
      })
  }
  
}
